module.exports = __webpack_public_path__ + ".well-known/img/google-pay.28b7d460.png";